import {polyfill} from 'es6-promise';
import $ from 'jquery';

import './vendor/zimpa/jquery.googlemaps-manager';
import './vendor/zimpa/jquery.research-scan-admin';
import './vendor/zimpa/jquery.scan';
import './vendor/zimpa/jquery.scan-admin';
import './vendor/zimpa/jquery.youtube-manager';

polyfill();

import { init } from "./lib/functions";

import './module/persona-scan-stats/index';
import './module/research-scan-stats/index';
import './module/quiz/index';

$(document).ready(function() {
  init();
});
